import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: '',
  data: [],
  total_results: 0,
  page: 1,
  has_next: false,
  has_prev: false,
  total_pages: 0,
  filters: { source_ref: '', phone_number: '', status: '', given_for: '', source_system: '', created_from: '', created_to: '' },
  balance: null,
  userPoints: [],
  userTotalResults: 0,
  userHasNext: false,
  userHasPrev: false,
  userTotalPages: 0,
  maturityLoading: false,
  batchPostLoading: false,
  batchCancelLoading: false,
  calculateLoading: false,
}

const rewardPointsSlice = createSlice({
  name: 'rewardPoints',
  initialState,
  reducers: {
    tryFetchPoints: () => {},
    tryFetchPointById: () => {},
    tryCreatePoint: () => {},
    tryCancelPoint: (state, action) => {
      const { pointId, sourceSystem } = action.payload
      return { ...state, pointCancelLoading: true, error: '' }
    },
    tryFetchUserBalance: () => {},
    tryFetchUserPoints: () => {},
    trySetMaturity: () => {},
    tryBatchPost: () => {},
    tryBatchCancel: () => {},
    tryCalculate: () => {},
    setPoints: (state, action) => {
      return {
        ...state,
        data: action.payload.data || [],
        total_results: action.payload.total_results || 0,
        page: action.payload.page || 1,
        has_next: action.payload.has_next || false,
        has_prev: action.payload.has_prev || false,
        total_pages: action.payload.total_pages || 0,
        loading: false,
        error: '',
      }
    },
    setPointDetail: (state, action) => {
      return { ...state, selectedItem: action.payload, loading: false, error: '' }
    },
    setUserBalance: (state, action) => {
      return { ...state, balance: action.payload, loading: false, error: '' }
    },
    setUserPoints: (state, action) => {
      return {
        ...state,
        userPoints: action.payload.data || [],
        userTotalResults: action.payload.total_results || 0,
        page: action.payload.page || 1,
        userHasNext: action.payload.has_next || false,
        userHasPrev: action.payload.has_prev || false,
        userTotalPages: action.payload.total_pages || 0,
        loading: false,
        error: '',
      }
    },
    setLoading: (state, action) => {
      return { ...state, loading: action.payload }
    },
    setError: (state, action) => {
      return { ...state, error: action.payload, loading: false }
    },
    setMaturityLoading: (state, action) => {
      return { ...state, maturityLoading: action.payload }
    },
    setBatchPostLoading: (state, action) => {
      return { ...state, batchPostLoading: action.payload }
    },
    setBatchCancelLoading: (state, action) => {
      return { ...state, batchCancelLoading: action.payload }
    },
    setCalculateLoading: (state, action) => {
      return { ...state, calculateLoading: action.payload }
    },
    setFilters: (state, action) => {
      const payload = action.payload
      if (payload.page !== undefined) {
        return { ...state, filters: { ...state.filters, ...payload }, page: payload.page }
      }
      return { ...state, filters: { ...state.filters, ...payload }, page: 1 }
    },
    resetPointsState: () => initialState,
  },
})

export const {
  tryFetchPoints,
  tryFetchPointById,
  tryCreatePoint,
  tryCancelPoint,
  tryFetchUserBalance,
  tryFetchUserPoints,
  trySetMaturity,
  tryBatchPost,
  tryBatchCancel,
  tryCalculate,
  setPoints,
  setPointDetail,
  setUserBalance,
  setUserPoints,
  setLoading,
  setError,
  setMaturityLoading,
  setBatchPostLoading,
  setBatchCancelLoading,
  setCalculateLoading,
  setFilters,
  resetPointsState,
} = rewardPointsSlice.actions

export default rewardPointsSlice.reducer